export interface PlannerLayoutInput {
    /** react-device-detect `isMobile`, i.e. the user agent. */
    isMobileUserAgent: boolean;
    /** `useIsPortraitDevices`, a touch screen held in portrait. */
    isPortraitDevices: boolean;
    /** `useIsMobileLandscape`, a small touch screen held in landscape. */
    isMobileLandscape: boolean;
}

export interface PlannerLayout {
    /** Product dropdown and floating menu over the scene. */
    showDesktopProductControls: boolean;
    /** The `Mobile` panel pinned to the bottom of the screen. */
    showMobileControls: boolean;
    /** PositionEditor rendered by the dashboard, the mobile panel has its own. */
    showDashboardPositionEditor: boolean;
    /** Share/tutorial/survey buttons inside the mobile panel. */
    showMobileHelpButtons: boolean;
    /** Desktop share/tutorial/survey/shortcut cluster (FloatingButtons). */
    showDesktopHelpButtons: boolean;
    /** The room planner menu as a fixed bar at the bottom of the screen. */
    showMobileBottomMenu: boolean;
    /** The footer room planner menu, it would cover the mobile bottom menu. */
    showFooterMenu: boolean;
    /** 3D preview beside the product editor, which is full screen on mobile. */
    showEditorPreview: boolean;
    /** Third party chat bubble, it covers the mobile bottom bars. */
    hideChatWidget: boolean;
    /** Open the product catalogue when the planner loads. */
    autoOpenCatalogue: boolean;
    /** Close the catalogue after a product is saved instead of going back to it. */
    closeCatalogueAfterSave: boolean;
    /** Footer with the note, otherwise the note floats above the bottom bars. */
    showBottomBar: boolean;
}

// The media queries pick the mobile layout, but some parts used to follow the
// user agent instead. A touch device with a desktop user agent (e.g. Surface
// Pro in portrait) then lost the product controls and the bottom menu, so
// every piece of the planner layout is decided here from the same inputs.
export const getPlannerLayout = ({
    isMobileUserAgent,
    isPortraitDevices,
    isMobileLandscape,
}: PlannerLayoutInput): PlannerLayout => {
    const isMobileLayout = isPortraitDevices || isMobileLandscape;
    const showMobileControls = isMobileUserAgent || isMobileLayout;
    // The desktop cluster floats over the bottom right, where the mobile
    // layout pins the product panel.
    const showDesktopHelpButtons = !isMobileUserAgent && !isMobileLayout;

    return {
        showDesktopProductControls: !isMobileLayout,
        showMobileControls,
        showDashboardPositionEditor: !showMobileControls,
        showMobileHelpButtons: !showDesktopHelpButtons,
        showDesktopHelpButtons,
        showMobileBottomMenu: isPortraitDevices,
        showFooterMenu: !isMobileUserAgent && !isPortraitDevices,
        showEditorPreview: !isMobileUserAgent && !isMobileLayout,
        hideChatWidget: isMobileLayout,
        // the catalogue is full screen on mobile and would cover the scene
        autoOpenCatalogue: !showMobileControls,
        closeCatalogueAfterSave: showMobileControls,
        // the fixed mobile bottom menu would cover the footer
        showBottomBar: !isMobileUserAgent && !isMobileLayout,
    };
};
